/**
 * Capitalizes the first character of a given string.
 * @param str - The input string to capitalize.
 * @returns The input string with its first letter capitalized, or an empty string if the input is invalid.
 */
export const capitalizeFirstCharacter = (str: string): string => {
  if (typeof str !== 'string' || str.length === 0) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Converts a string to kebab case by replacing spaces with hyphens.
 * @param {string} str - The string to convert.
 * @returns {string} The kebab case version of the string.
 * @example
 * toKebabCase('User Profile')     // Returns: "user-profile"
 */
export const toKebabCase = (str: string): string => {
  return str.toLowerCase().replace(/\s+/g, '-');
};
